/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './diaglab-sample-item.reducer';

export const DiaglabSampleItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const diaglabSampleItemList = useAppSelector(state => state.diaglabSampleItem.entities);
  const loading = useAppSelector(state => state.diaglabSampleItem.loading);
  const totalItems = useAppSelector(state => state.diaglabSampleItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="diaglab-sample-item-heading" data-cy="DiaglabSampleItemHeading">
        <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.home.title">Diaglab Sample Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/diaglab-sample-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.home.createLabel">Create new Diaglab Sample Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.diaglabSampleItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {diaglabSampleItemList && diaglabSampleItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('itemAccessionNo')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.itemAccessionNo">Item Accession No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('itemAccessionNo')} />
                </th>
                <th className="hand" onClick={sort('referredToOrFrom')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.referredToOrFrom">Referred To Or From</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredToOrFrom')} />
                </th>
                <th className="hand" onClick={sort('quantity')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.quantity">Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantity')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('typeOfSample')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.typeOfSample">Type Of Sample</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('typeOfSample')} />
                </th>
                <th className="hand" onClick={sort('testSquence')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.testSquence">Test Squence</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('testSquence')} />
                </th>
                <th className="hand" onClick={sort('rejectReason')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.rejectReason">Reject Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejectReason')} />
                </th>
                <th className="hand" onClick={sort('uom')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.uom">Uom</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uom')} />
                </th>
                <th className="hand" onClick={sort('collectionDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.collectionDate">Collection Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectionDate')} />
                </th>
                <th className="hand" onClick={sort('enteredDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.enteredDate">Entered Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('enteredDate')} />
                </th>
                <th className="hand" onClick={sort('sendingdDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.sendingdDate">Sendingd Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sendingdDate')} />
                </th>
                <th className="hand" onClick={sort('receivedDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.receivedDate">Received Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('receivedDate')} />
                </th>
                <th className="hand" onClick={sort('acceptingDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.acceptingDate">Accepting Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('acceptingDate')} />
                </th>
                <th className="hand" onClick={sort('precessingDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.precessingDate">Precessing Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('precessingDate')} />
                </th>
                <th className="hand" onClick={sort('completionDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.completionDate">Completion Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('completionDate')} />
                </th>
                <th className="hand" onClick={sort('verificationDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.verificationDate">Verification Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('verificationDate')} />
                </th>
                <th className="hand" onClick={sort('authenticationDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.authenticationDate">Authentication Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('authenticationDate')} />
                </th>
                <th className="hand" onClick={sort('releasedDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.releasedDate">Released Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('releasedDate')} />
                </th>
                <th className="hand" onClick={sort('transmissionDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.transmissionDate">Transmission Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transmissionDate')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.sample">Sample</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.labTestItem">Lab Test Item</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.collector">Collector</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {diaglabSampleItemList.map((diaglabSampleItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/diaglab-sample-item/${diaglabSampleItem.id}`} color="link" size="sm">
                      {diaglabSampleItem.id}
                    </Button>
                  </td>
                  <td>{diaglabSampleItem.itemAccessionNo}</td>
                  <td>{diaglabSampleItem.referredToOrFrom}</td>
                  <td>{diaglabSampleItem.quantity}</td>
                  <td>{diaglabSampleItem.active ? 'true' : 'false'}</td>
                  <td>{diaglabSampleItem.cursor}</td>
                  <td>{diaglabSampleItem.lastUpdated}</td>
                  <td>{diaglabSampleItem.microSec}</td>
                  <td>{diaglabSampleItem.timestampEntry}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SampleStatus.${diaglabSampleItem.status}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TypeOfSample.${diaglabSampleItem.typeOfSample}`} />
                  </td>
                  <td>{diaglabSampleItem.testSquence}</td>
                  <td>{diaglabSampleItem.rejectReason}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.UOM.${diaglabSampleItem.uom}`} />
                  </td>
                  <td>{diaglabSampleItem.collectionDate}</td>
                  <td>{diaglabSampleItem.enteredDate}</td>
                  <td>{diaglabSampleItem.sendingdDate}</td>
                  <td>{diaglabSampleItem.receivedDate}</td>
                  <td>{diaglabSampleItem.acceptingDate}</td>
                  <td>{diaglabSampleItem.precessingDate}</td>
                  <td>{diaglabSampleItem.completionDate}</td>
                  <td>{diaglabSampleItem.verificationDate}</td>
                  <td>{diaglabSampleItem.authenticationDate}</td>
                  <td>{diaglabSampleItem.releasedDate}</td>
                  <td>{diaglabSampleItem.transmissionDate}</td>
                  <td>
                    {diaglabSampleItem.sample ? (
                      <Link to={`/diaglab-sample/${diaglabSampleItem.sample.id}`}>{diaglabSampleItem.sample.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabSampleItem.labTestItem ? (
                      <Link to={`/user-lab-test-item/${diaglabSampleItem.labTestItem.id}`}>{diaglabSampleItem.labTestItem.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diaglabSampleItem.collector ? (
                      <Link to={`/diaglab-assistant/${diaglabSampleItem.collector.id}`}>{diaglabSampleItem.collector.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/diaglab-sample-item/${diaglabSampleItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/diaglab-sample-item/${diaglabSampleItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/diaglab-sample-item/${diaglabSampleItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.home.notFound">No Diaglab Sample Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={diaglabSampleItemList && diaglabSampleItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiaglabSampleItem;
